import {
  Button,
  Checkbox,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Grid,
  makeStyles,
} from "@material-ui/core";
import React from "react";
import ArrowRightAltIcon from "@material-ui/icons/ArrowRightAlt";
import styles from "./informationModal.module.scss";
import { GDPRModal } from "./GDPRModal";
import { useTranslation } from "react-i18next";

const useStyles = makeStyles({
  checkbox: {
    paddingLeft: 0,
  },
  GDPRText: {
    marginBottom: 0,
    fontSize: 16,
  },
  integrityText: {
    textDecoration: "underline",
    padding: 0,
  },
});
export const InformationModal: React.FC<any> = (props) => {
  const [openDialog, setOpenDialog] = React.useState<boolean>(false);
  const classes = useStyles();

  const onOpenDialog = () => {
    setOpenDialog(true);
  };
  const onClose = () => {
    setOpenDialog(false);
  };

  const [gdprApproved, setGdprApproved] = React.useState<boolean>(false);
  const { t } = useTranslation();
  return (
    <Grid container direction="column" wrap="nowrap">
      <DialogContent>
        <DialogTitle>{t("Information on shell protection")}</DialogTitle>
        <DialogContentText color="primary">
          {t(
            "By activating the shell protection, you can see if doors and windows are open or closed."
          )}{" "}
          <br /> <br />
          {t(
            "You can activate all objects in the apartment at once or activate individual objects."
          )}
          <br />
          <br />{" "}
          {t(
            "Start by registering which telephone number the text message should be sent to."
          )}
        </DialogContentText>
        <Grid container direction="column" alignItems="baseline">
          <Button
            onClick={() => onOpenDialog()}
            color="secondary"
            classes={{ root: classes.integrityText }}
          >
            {t("Read our privacy policy")}
          </Button>
          <div className={styles.approveGDPR}>
            <Checkbox
              color="primary"
              classes={{ root: classes.checkbox }}
              onChange={(e) => setGdprApproved(e.target.checked)}
            />
            <DialogContentText
              color="primary"
              classes={{ root: classes.GDPRText }}
            >
              {t("I hereby approve the attached privacy policy")}
            </DialogContentText>
          </div>
        </Grid>
      </DialogContent>
      <DialogActions>
        <Button
          fullWidth
          variant="contained"
          color="secondary"
          endIcon={<ArrowRightAltIcon fontSize="medium" />}
          onClick={props.nextStep}
          disabled={!gdprApproved}
        >
          {t("Register phone number for activation of shell protection")}
        </Button>
      </DialogActions>
      <GDPRModal open={openDialog} onClose={onClose}></GDPRModal>
    </Grid>
  );
};
